'use client';

import React, { useState } from 'react';

import Image from 'next/image';

import CopyIcon from '@/assets/images/copy-icon-02.svg';
import Button from '@/components/V2/Button';
import Modal from '@/components/V2/Modal';

import '@/styles/globals.v2.css';

import WebaliasLink from '@/components/Link/WebaliasLink';
import Spinner from '@/components/V2/Spinner';
import Tooltip from '@/components/V2/Tooltip';
import cn from '@/helpers/utils/classNames';

import { useInterstitialContext } from '../InterstitialModalsContext';
import InterstitialModalCloseButton from './InterstitialModalCloseButton';

const SucessAndCopyCodeModal = ({}: {}) => {
  const [copyText, setCopyText] = useState('Copy');
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const { data, closeModal, modals } = useInterstitialContext();

  const handleCopy = () => {
    const couponCode = data?.successPopup?.couponCode;
    if (couponCode) {
      navigator.clipboard.writeText(couponCode);
      setCopyText('Copied');
      setTimeout(() => {
        setCopyText('Copy');
      }, 4000);
    }
  };

  return (
    <Modal
      isOpen={modals.showSuccessModal}
      onClose={() => closeModal('showSuccessModal')}
      className="v2-w-[712px] md:v2-w-[712px] sm:v2-w-[712px] xs:v2-w-[712px] !v2-p-0"
      closeBtnClassName="v2-top-4 !v2-right-4 v2-w-4 v2-h-4"
      closeButton={props => (
        <InterstitialModalCloseButton
          {...props}
          className={cn(props.className, '!v2-bg-transparent')}
          iconClassName="!v2-invert-0"
        />
      )}
    >
      <div className="v2-w-full v2-px-4 v2-pt-12 v2-pb-4">
        <p className="v2-font-sweet-sans-pro v2-font-normal v2-text-base v2-text-[#212427] v2-mb-2 md:v2-mb-3">
          {data?.successPopup?.topContent ?? ''}
        </p>
        <h2 className="v2-text-2xl v2-font-normal v2-font-sweet-sans-pro v2-text-[#212427] v2-mb-2 md:v2-mb-3">
          {data?.successPopup?.heading ?? ''}
        </h2>
        <p className="v2-font-sweet-sans-pro v2-font-normal v2-text-sm v2-text-[#212427] v2-mb-2 md:v2-mb-3">
          {data?.successPopup?.description ?? ''}
        </p>
        <div className="v2-bg-[#F3F6F5] v2-border v2-border-dashed v2-border-[#C8D2D1] v2-flex v2-items-center v2-justify-center v2-gap-2 v2-rounded-xs v2-h-[80px] v2-mb-2 md:v2-mb-3">
          <p className="v2-text-primary v2-text-3xl v2-font-sweet-sans-pro v2-font-normal">
            {data?.successPopup?.couponCode ?? ''}
          </p>
          <Tooltip variant="light" title={copyText} placement="top">
            <Image src={CopyIcon} alt="" role="button" onClick={handleCopy} />
          </Tooltip>
        </div>
        <WebaliasLink href={data?.successPopup.buttonLink || '#'} as={'a'}>
          <Button
            type="button"
            btnSize="md"
            scheme="primary"
            variant="filled"
            onClick={() => setIsLoadingModal(true)}
            disabled={isLoadingModal}
            className="v2-text-sm v2-leading-[28px] v2-font-sweet-sans-pro-medium v2-font-medium v2-py-[10px] v2-w-full v2-flex v2-justify-center v2-items-center v2-gap-2 v2-mb-0"
          >
            {isLoadingModal && <Spinner />}

            {data?.successPopup?.buttonText ?? ''}
          </Button>
        </WebaliasLink>
      </div>
    </Modal>
  );
};

export default SucessAndCopyCodeModal;
